module.exports = __webpack_public_path__ + "static/media/Bandit.99696dc7.jpg";